import Vue from 'vue';
import VueRouter, { RawLocation } from 'vue-router';

import Layout from '../pages/layout.vue';
import Cvs from '../pages/cvs/index.vue';
import CvNew from '../pages/cvs/new.vue';
import CvSections from '../pages/cvs/_cvId/edit/index.vue';
import CvProfileEdit from '../pages/cvs/_cvId/profile/edit.vue';
import CvTextNew from '../pages/cvs/_cvId/texts/new.vue';
import CvTextEdit from '../pages/cvs/_cvId/texts/edit.vue';
import CvDateNew from '../pages/cvs/_cvId/dates/new.vue';
import CvDateEdit from '../pages/cvs/_cvId/dates/edit.vue';
import CvDateItemNew from '../pages/cvs/_cvId/dates/_cv_section_date_id/items/new.vue';
import CvDateItemEdit from '../pages/cvs/_cvId/dates/_cv_section_date_id/items/edit.vue';
import CvSkillNew from '../pages/cvs/_cvId/skills/new.vue';
import CvSkillEdit from '../pages/cvs/_cvId/skills/edit.vue';
import CvSkillItemNew from '../pages/cvs/_cvId/skills/_cv_section_skill_id/items/new.vue';
import CvSkillItemEdit from '../pages/cvs/_cvId/skills/_cv_section_skill_id/items/edit.vue';
import CvLinkNew from '../pages/cvs/_cvId/links/new.vue';
import CvLinkEdit from '../pages/cvs/_cvId/links/edit.vue';
import CvLinkItemNew from '../pages/cvs/_cvId/links/_cv_section_link_id/items/new.vue';
import CvLinkItemEdit from '../pages/cvs/_cvId/links/_cv_section_link_id/items/edit.vue';
import CvGalleryNew from '../pages/cvs/_cvId/galleries/new.vue';
import CvGalleryEdit from '../pages/cvs/_cvId/galleries/edit.vue';
import CvGalleryItemNew from '../pages/cvs/_cvId/galleries/_cv_section_gallery_id/items/new.vue';
import CvGalleryItemEdit from '../pages/cvs/_cvId/galleries/_cv_section_gallery_id/items/edit.vue';
import CvDesign from '../pages/cvs/_cvId/design/index.vue';
import CvPreview from '../pages/cvs/_cvId/preview/index.vue';
import CvSetting from '../pages/cvs/_cvId/setting/index.vue';
import CoverLetterNew from '../pages/cover-letters/new.vue';
import CoverLetterEdit from '../pages/cover-letters/edit.vue';
import Error404 from '../pages/errors/404.vue';

import store from '../store';
import * as ErrorStore from '../store/modules/error';

Vue.use(VueRouter);
Vue.mixin({
  methods: {
    /**
     * Do history back only if SP device
     * @param routerOptions
     */
    async $backOrGoTo(routerOptions: RawLocation) {
      this.$ua.isMobile
        ? await this.$router.back()
        : await this.$router.push(routerOptions);
    },
  },
});

const pathPrefix = 'app';
const routes = [
  {
    path: `/${pathPrefix}`,
    component: Layout,
    children: [
      {
        path: ``,
        name: 'home_path',
        redirect: {
          name: 'cvs_path',
        },
      },
      {
        path: `cvs`,
        component: Cvs,
        name: 'cvs_path',
        meta: { title: 'ダッシュボード' },
      },
      {
        path: `cvs/new`,
        component: CvNew,
        name: 'cvs_new_path',
        meta: { title: '履歴書を作成' },
      },
      {
        path: `cvs/:cv_id`,
        component: CvSections,
        name: 'cv_edit_path',
        children: [
          {
            path: 'profile/edit',
            component: CvProfileEdit,
            name: 'cv_section_profile_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'texts/new',
            component: CvTextNew,
            name: 'cv_section_texts_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'texts/:id/edit',
            component: CvTextEdit,
            name: 'cv_section_texts_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'dates/new',
            component: CvDateNew,
            name: 'cv_section_dates_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'dates/:id/edit',
            component: CvDateEdit,
            name: 'cv_section_dates_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'dates/:cv_section_date_id/items/new',
            component: CvDateItemNew,
            name: 'cv_section_date_items_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'dates/:cv_section_date_id/items/:id/edit',
            component: CvDateItemEdit,
            name: 'cv_section_date_items_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'skills/new',
            component: CvSkillNew,
            name: 'cv_section_skills_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'skills/:id/edit',
            component: CvSkillEdit,
            name: 'cv_section_skills_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'skills/:cv_section_skill_id/items/new',
            component: CvSkillItemNew,
            name: 'cv_section_skill_items_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'skills/:cv_section_skill_id/items/:id/edit',
            component: CvSkillItemEdit,
            name: 'cv_section_skill_items_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'links/new',
            component: CvLinkNew,
            name: 'cv_section_links_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'links/:id/edit',
            component: CvLinkEdit,
            name: 'cv_section_links_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'links/:cv_section_link_id/items/new',
            component: CvLinkItemNew,
            name: 'cv_section_link_items_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'links/:cv_section_link_id/items/:id/edit',
            component: CvLinkItemEdit,
            name: 'cv_section_link_items_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'galleries/new',
            component: CvGalleryNew,
            name: 'cv_section_galleries_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'galleries/:id/edit',
            component: CvGalleryEdit,
            name: 'cv_section_galleries_edit_path',
            meta: { preservePosition: true },
          },
          {
            path: 'galleries/:cv_section_gallery_id/items/new',
            component: CvGalleryItemNew,
            name: 'cv_section_gallery_items_new_path',
            meta: { preservePosition: true },
          },
          {
            path: 'galleries/:cv_section_gallery_id/items/:id/edit',
            component: CvGalleryItemEdit,
            name: 'cv_section_gallery_items_edit_path',
            meta: { preservePosition: true },
          },
        ],
      },
      {
        path: `cvs/:cv_id/preview`,
        component: CvPreview,
        name: 'cv_preview_path',
        meta: { title: 'プレビュー' },
      },
      {
        path: `cvs/:cv_id/design`,
        component: CvDesign,
        name: 'cv_design_path',
        meta: { title: 'デザイン選択' },
      },
      {
        path: `cvs/:cv_id/setting`,
        component: CvSetting,
        name: 'cv_setting_path',
        meta: { title: '設定' },
      },
      {
        path: `cls/new`,
        component: CoverLetterNew,
        name: 'cover_letters_new_path',
        meta: { title: '志望動機書を作成' },
      },
      {
        path: `cls/:id/edit`,
        component: CoverLetterEdit,
        name: 'cover_letter_edit_path',
      },
      { path: '*', component: Error404, name: 'error_404' },
    ],
  },
];

const scrollBehavior = (_to, from, savedPosition) => {
  if (from.meta && from.meta.preservePosition) {
    return;
  }

  if (savedPosition) {
    return savedPosition;
  } else if (from.path === '/app/cvs') {
    return { x: 0, y: 0 };
  }
  return { x: 0, y: 0 };
};

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior,
});
router.beforeEach((_to, _from, next) => {
  store.dispatch(
    ErrorStore.ClearErrors(null, { namespace: ErrorStore.namespace })
  );
  next();
});

export default router;
